module.exports = {
    Get_Data_Event: "Get_Data_Event",

    Get_List_Event: "Get_List_Event",

    Rank_List_Event: "Rank_List_Event",

    Can_Get_Red_Bag: "Can_Get_Red_Bag",

    Update_Red_Bag_Event: "Update_Red_Bag_Event"
}